import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=005fbce7&"
import script from "./FileDetail.vue?vue&type=script&lang=js&"
export * from "./FileDetail.vue?vue&type=script&lang=js&"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=005fbce7&prod&lang=scss&"
import style1 from "./FileDetail.vue?vue&type=style&index=1&id=005fbce7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports